let content;
let header;
let modalsContainer;
let active = null;

export default () => {
    const triggers = getTriggers();

    if (triggers.length === 0) {
        return;
    }

    content = document.getElementById('content');
    header = document.getElementById('header');
    modalsContainer = document.querySelector('.modals');

    getClosers().forEach((closer) => {
        closer.addEventListener('click', () => {
            if (active !== null) {
                closeModal(active);
            }
        });
    });

    triggers.forEach((trigger) => {
        trigger.addEventListener('click', (e) => {

            if (active !== null) {
                closeModal(active);
            }

            const target = getMemberElement(e.target);

            openModal(target.getAttribute('data-code'));
        });
    });

    modalsContainer.addEventListener('click', (e) => {
        e.stopPropagation();
        e.preventDefault();

        if (e.target === modalsContainer && active !== null) {
            closeModal(active);
        }

        return false;
    });

    window.addEventListener('resize', () => {
        if (active === null) {
            return;
        }

        const activeModal = getModal(active);

        if (window.innerWidth >= 1024) {
            activeModal.style.marginTop = (((window.innerHeight - activeModal.offsetHeight) / 2) / 2) + 'px';

            if (!activeModal.classList.contains('flex')) {
                activeModal.classList.add('flex');
            }
        } else {
            activeModal.style.marginTop = '0';

            if (activeModal.classList.contains('flex')) {
                activeModal.classList.remove('flex');
            }
        }
    }, true);
};

function getMemberElement(element) {
    if (!element.classList.contains('member')) {
        return getMemberElement(element.parentNode);
    }

    return element;
}

function getTriggers() {
    return document.querySelectorAll('.member');
}

function getClosers() {
    return document.querySelectorAll('[data-trigger="close"]');
}

function openModal(code) {
    content.classList.add('blur-md');
    header.classList.add('blur-md');
    modalsContainer.classList.remove('hidden');
    modalsContainer.classList.add('flex');

    showModal(code);

    active = code;
}

function getModal(code) {
    return document.getElementById(code);
}

function closeModal(code) {
    content.classList.remove('blur-md');
    header.classList.remove('blur-md');
    modalsContainer.classList.add('hidden');
    modalsContainer.classList.remove('flex');

    if (active !== code) {
        hideModal(active);
    }

    hideModal(code);

    active = null;
}

function hideModal(code) {
    getModal(code).classList.add('hidden');

    getModal(code).classList.remove('flex');
}

function showModal(code) {
    getModal(code).classList.remove('hidden');

    if (window.innerWidth >= 1024) {
        getModal(code).classList.add('flex');

        getModal(code).style.marginTop = (((window.innerHeight - getModal(code).offsetHeight) / 2) / 2) + 'px';
    } else {
        getModal(code).classList.remove('flex');
    }
}
